const honorificPrefixes = [
    "Mr.", "Mr", "Mrs.", "Mrs", "Ms.", "Ms", "Mx.", "Mx", "Miss", "Master", "Dr.", "Dr", "Prof.", "Prof",
    "Br.", "Br", "Sr.", "Sr", "Fr.", "Fr", "Rev.", "Rev", "Pr.", "Pr", "Capt.", "Capt", "Major",
    "Lt.", "Lt", "Sgt.", "Sgt", "Cpl.", "Cpl", "Hon.", "Hon", "Amb.", "Amb", "Gov.", "Gov",
    "Pres.", "Pres", "V.Pres.", "V.Pres", "Bp.", "Bp", "Archbp.", "Archbp", "Card.", "Card",
    "Atty.", "Atty", "Solic.", "Solic", "Barr.", "Barr", "Bench", "Rabbi", "Imam", "Shaykh",
    "His", "Her", "Your", "Their", "HH", "HSH", "HRH", "HE", "HM", "Kaiser", "Tsar", "Tsarina",
    "Raja", "Rani", "Lord", "Lady", "Sir", "Dame", "Madam", "Señor", "Señora", "Señorita",
    "Herr", "Frau", "Fräulein", "Herr Dr.", "Herr Professor Dr"
];

const honorificSuffixes = [
    "II", "III", "IV", "V", "Jr.", "Jr", "Sr.", "Sr", "DPhil", "PhD", "Ph.D.", "MD", "M.D.", "DO",
    "DDS", "D.D.S.", "DMD", "D.M.D.", "OD", "O.D.", "DC", "D.C.", "PharmD", "Pharm.D.", "JD", "J.D.", "Esq.",
    "RN", "R.N.", "LPN", "L.P.N.", "LVN", "L.V.N.", "CNA", "C.N.A.", "NP", "N.P.", "PA", "P.A.", "PT", "P.T.",
    "OT", "O.T.", "RRT", "R.R.T.", "CCM", "C.C.M.", "FACC", "F.A.C.C.", "FAAN", "F.A.A.N.", "MA", "M.A.",
    "MS", "M.S.", "MSc", "M.Sc.", "BA", "B.A.", "BS", "B.S.", "BSc", "B.Sc.", "ARSM", "A.R.S.M.", "FRSA",
    "F.R.S.A.", "FSA", "F.S.A.", "FRCPath", "F.R.C.Path.", "FRSC", "F.R.S.C.", "FREng", "F.R.Eng.",
    "FRHistS", "F.R.Hist.S.", "FRSL", "F.R.S.L.", "FRSE", "F.R.S.E.", "FRSAE", "F.R.S.A.E.", "FRSS", "F.R.S.S.",
    "FRAS", "F.R.A.S.", "QPM", "Q.P.M.", "KBE", "K.B.E.", "DBE", "D.B.E.", "CBE", "C.B.E.", "OBE", "O.B.E.", "MBE", "M.B.E."
];

module.exports = { honorificPrefixes, honorificSuffixes };